import { Component, OnInit, Input, ViewChild, Output, EventEmitter, AfterViewInit, ElementRef } from '@angular/core';
import { ConfirmComponent } from '../../shared/component/confirm/confirm.component';
import { HeaderDefaultModel } from '../../shared/model/header-default.model';
import { HeaderItemModel } from '../../shared/model/header-item.model';
import { HeaderQRCodeModel } from '../../shared/model/header_qrcode.model';
import { HeaderDefaultService } from '../../shared/service/header-default.service';
import { HeaderDefaultModalComponent } from './header-default-modal/header-default-modal.component';


@Component({
	selector: 'app-header-default',
	templateUrl: './header-default.component.html',
	styleUrls: ['./header-default.component.css']
})
export class HeaderDefaultComponent implements OnInit {

	@ViewChild(HeaderDefaultModalComponent) headerDefaultModal: HeaderDefaultModalComponent;
	@ViewChild(ConfirmComponent) confirm: ConfirmComponent;
	@Input() headerDefaults: HeaderDefaultModel[];
	@Input() headerItems: HeaderItemModel[];
	@Input() checklist_id: number;
	headerDefaultSelect: HeaderDefaultModel;
	qrCodeDisplay = false;
	rowIndex: number = null;
	idSelect: number = -1;

	constructor(private headerDefaultService: HeaderDefaultService) { }

	ngOnInit() {
	}

	deleteHeaderDefault(row: HeaderDefaultModel) {
		this.rowIndex = this.headerDefaults.indexOf(row);
		this.idSelect = row.id;
		this.confirm.key = "header-default";
		this.confirm.confirm();
	}

	acceptDeleteHeaderDefault() {
		this.headerDefaultService.delete(this.idSelect).subscribe(res => {
			this.headerDefaults.splice(this.rowIndex, 1);
		});
	}

	rejectDeleteHeaderDefault() {
		this.rowIndex = null;
	}

	saveHeaderDefaults(response: any) {
		if (this.rowIndex != null) {
			// console.log(response);
			if (response.id) {
				this.headerDefaults[this.rowIndex].id = response.id;
				this.headerDefaults[this.rowIndex].name = response.name;
				this.headerDefaults[this.rowIndex].headerDefaultItems = response.headerDefaultItems;
			} else {
				this.headerDefaults[this.rowIndex] = response;
			}
		} else {
			this.headerDefaults.push(response);
		}

		this.rowIndex = null;
		this.headerDefaultModal.display = false;
	}

	openModal(headerDefault?) {

		if (headerDefault) {
			this.rowIndex = this.headerDefaults.indexOf(headerDefault);
			this.headerDefaultModal.headerDefault = headerDefault as HeaderDefaultModel 
			if (!this.headerDefaultModal.headerDefault.qrcode_id) {
				this.headerDefaultModal.headerDefault.qrcode = { code: Math.random().toString(36).substr(2, 6) } as HeaderQRCodeModel
			}
			
		} else {
			this.rowIndex = null;
			this.headerDefaultModal.headerDefault = new HeaderDefaultModel(this.checklist_id);
			this.headerDefaultModal.headerDefault.qrcode = { code: Math.random().toString(36).substr(2, 6) } as HeaderQRCodeModel
			// this.headerDefaultModal.headerDefault.qrcode
		}
		this.headerDefaultModal.headerItems = this.headerItems;
		this.headerDefaultModal.checklist_id = this.checklist_id;
		this.headerDefaultModal.display = true;
	}

	generateQRCode(headerDefault?) {
		this.headerDefaultSelect = headerDefault;
		this.qrCodeDisplay = true;
	}

	closeQrCode($event: any) {
		this.qrCodeDisplay = false;
	}
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/header-default/header-default.component.ts